import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserSessionService } from './../../../UserSession/user-session.service';
import { CustomEntityUtils } from './../../../custom-entity-utils.service';

@Component({
  selector: 'ngx-custom-entity-field',
  templateUrl: './custom-entity-field.component.html',
  styleUrls: ['./custom-entity-field.component.scss']
})
export class CustomEntityFieldComponent implements OnInit {


  private waitToEdEnabled: boolean;
  private isChanged: boolean;
  public fieldProps: any = {};
  public edEnabled: boolean;
  //Entradas
  @Input()
  public set fieldProperties(val: any){

    console.log('Seteamos fieldproperties');
      this.fieldProps = val



      if(!this.fieldProps.multiple && !Array.isArray(this.fieldProps.value)){
        this.fieldProps.value = [this.fieldProps.value];
      }

      this.fieldProps.componentRef = this;
      if(this.edEnabled === true && this.waitToEdEnabled === true){
        this.fillElements();
      }

  };

  @Input()
  public set editionEnabled(val: any){
    this.edEnabled = val;
    if(this.edEnabled === true){

      if(this.fieldProps.customEntityConfig != undefined){
        this.fillElements();
      }else{
        this.waitToEdEnabled = true;
      }

    }
  }

  public entityElements: any[];

  protected fieldEntity: any;

  protected availableElements: any[];

  @Input()
  private value: any;

  @Output()
  private onChangeValue: EventEmitter<any> = new EventEmitter();

  private filterLastExecution: any = null;

  private filteredBy: string;

  dropdownSettings = {
    singleSelection: false,
    allowSearchFilter: true,
    searchPlaceholderText:"Buscar",
    enableCheckAll:false
  };

  dropdownSettingsSingle = {
    singleSelection: true,
    allowSearchFilter: true,
    searchPlaceholderText:"Buscar",
    enableCheckAll:false
  };
  userSelected: boolean;

  constructor(private userSessionService: UserSessionService) { }

  ngOnInit(): void {

    console.log('Inicializacions componente customentityfield');
  }
  fillElements() {
    this.userSessionService.getCachedCustomEntitiesFullList(undefined).subscribe(data => {
        this.fieldEntity = JSON.parse(JSON.stringify(data.find(entity => entity.id == this.fieldProps.customEntityConfig.entity)));
        if(this.fieldEntity.elements.length > 0){
          this.availableElements = this.fieldEntity.elements
          .filter( e => e.workingfrom == undefined && e.workinguntil == undefined  && e.disabledAt == undefined && e.archivedAt == undefined);
          this.fillOriginalElements();
        }


        console.log('Tenemos la entidad');
        //Hay que disparar el evento inicial

        if(this.fieldProps.value != null && this.fieldProps.value.length > 0){
          var valores = JSON.parse(JSON.stringify(this.fieldProps.value));
          let completeValues = this.fieldEntity.elements.filter(e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key && this.fieldProps.value.includes(attr.value)))


          if(completeValues.filter(cv => cv.archivedAt != undefined && cv.archivedAt != null && cv.archivedAt != '').length == 0){
            setTimeout(()=>{
              this.userSelected = true;
              this.fieldProps.value = valores;
              this.onChangeValue.emit({values:completeValues,sourceField:this.fieldProps.key,fieldEntity:this.fieldEntity});

            },200 +(10*Number(this.fieldProps.pos)));
          }










        }


    });

  }


  private fillOriginalElements() {
    this.userSelected = false;
    if (this.fieldProps.value != null && Array.isArray(this.fieldProps.value)){
      this.fieldProps.value.forEach((val,index)=>{

        if(val != null && val != '' && !this.availableElements.find((ae => {
          var attr = ae.attributes.find(atr => atr.id == this.fieldProps.customEntityConfig.key);
          return attr.value == val;
        }))){

          var archivedValue = this.fieldEntity.elements.find(e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key && attr.value == val));


          if(archivedValue){
             this.availableElements.push(archivedValue);
          }else{
            //El elemento sele
            this.availableElements.push({
              id: `archived_${index}`,
              entity_id: this.fieldProps.customEntityConfig.entity,
              name: val,
              attributes:[{id:this.fieldProps.customEntityConfig.key,value: val}],
            });
          }


        }
      });
    }


    this.entityElements = this.availableElements.map(elemento => {

      //Buscamos los atributos
      var clave = this.fieldProps.customEntityConfig.key;
      var valor = elemento.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key).value;
      return valor;

    })
    .filter(e => e != null)
    .sort((ea,eb)=> ea.toLowerCase() < eb.toLowerCase() ? -1 : 1)

    //Añadimos el valor





    this.entityElements = [...new Set(this.entityElements)];
  }

  triggerChangeValue(event:any){
    console.log('Recibido triggerChangeValue');
    var filteredElements;
    let impactedFields = event.impactedFields;
    if(impactedFields == undefined){
      impactedFields = [];
    }
    impactedFields.push(this.fieldProps.key);
    //Si es la misma entidad
    if(event.fieldEntity.id == this.fieldEntity.id){

      if(event.values.length == 0){
        //Es un evento de clearAll
        delete this.filteredBy;
        //Ponemos todos los elementos
        this.fillOriginalElements();
        this.fieldProps.value = [];
        //Lanzamos un evento de limpieza
        this.onChangeValue.emit({values:[],impactedFields:impactedFields,
          sourceField:this.fieldProps.key,fieldEntity:this.fieldEntity,originField:event.sourceField,depGroups:event.depGroups});

      }else{

          //Obtengo los elementos
          filteredElements = event.values.map(elemento => {

            //Buscamos los atributos
            var clave = this.fieldProps.customEntityConfig.key;
            var valor = elemento.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key);
            if(valor != undefined){
              return valor.value;
            }
            return null;


          }).filter( v => v != null);


          //Quitamos los duplicados
          filteredElements = [...new Set(filteredElements)];

          var elementsMatched = filteredElements.reduce((a, c) => a + this.entityElements.includes(c), 0)
          if(this.filteredBy != undefined && !event.depGroups.groups[event.depGroups.current].elements.includes(this.filteredBy) &&
           this.entityElements.length > 0){
            filteredElements = this.getIntersection(filteredElements,this.entityElements);
            filteredElements = [...new Set(filteredElements)];
          }

          if(filteredElements.length > 1 && !this.isCurrentValueInFilteredElements(filteredElements)){

            /*
            if(event.executionTimestamp == this.filterLastExecution && elementsMatched > 0){
              filteredElements = filteredElements.filter( fe => this.entityElements.includes(fe));
            }
            */
              this.entityElements = filteredElements.sort((ea,eb)=> ea.toLowerCase() < eb.toLowerCase() ? -1 : 1);

              if(this.filteredBy  == undefined){
                if(event.originField != undefined){
                  this.filteredBy = event.originField;
                }else{
                  this.filteredBy = event.sourceField;
                }
              }

          }else if(filteredElements.length == 1 && elementsMatched == 0){
            this.entityElements = filteredElements.sort((ea,eb)=> ea.toLowerCase() < eb.toLowerCase() ? -1 : 1);
            if(this.filteredBy  == undefined) this.filteredBy = event.sourceField;
          }




      }



    }else {

      if(event.values.length == 0){
        //Es un evento de clearAll
        //Ponemos todos los elementos
        this.fillOriginalElements();
        this.fieldProps.value = [];
        delete this.filteredBy;
        //Lanzamos un evento de limpieza
        this.onChangeValue.emit({values:[],impactedFields:impactedFields,
          sourceField:this.fieldProps.key,fieldEntity:this.fieldEntity,originField:event.sourceField,depGroups:event.depGroups});

      }else{
        var allJoins = [];
        event.values.forEach(value =>  {
          allJoins = allJoins.concat(value.joins.filter( j => j.entity_id == this.fieldEntity.id))
        });

        //TODO: Hay que buscar los joinsByAttribute
       let attributeJoin = event.fieldEntity.attributejoins.find(aj => aj.entity == this.fieldEntity.id);
       if(null != attributeJoin){
           var elementJoins = this.availableElements.filter(e => {
            var valorAtributo = e.attributes.find(a => a.id == attributeJoin.attributeTarget).value;
            return event.values.find(e => e.attributes.find(as => as.id == attributeJoin.attributeSource).value == valorAtributo);
          })
          allJoins = allJoins.concat(elementJoins);
       }


       filteredElements = allJoins.map(elemento => {

        //Buscamos los atributos
        var clave = this.fieldProps.customEntityConfig.key;
        var valor = elemento.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key).value
        return valor;

      });

      filteredElements = [...new Set(filteredElements)];
      var elementsMatched = filteredElements.reduce((a, c) => a + this.entityElements.includes(c), 0)
      if(this.filteredBy != undefined && !event.depGroups.groups[event.depGroups.current].elements.includes(this.filteredBy) &&
           this.entityElements.length > 0){
            filteredElements = this.getIntersection(filteredElements,this.entityElements);
            filteredElements = [...new Set(filteredElements)];
          }

      //Si no hay un único elemento  y el valor que tenemos seleccionado no está en los elementos filtrados filtramos

      if(filteredElements.length > 1 && !this.isCurrentValueInFilteredElements(filteredElements)){

        if(event.executionTimestamp == this.filterLastExecution && elementsMatched > 0){
          filteredElements = filteredElements.filter( fe => this.entityElements.includes(fe));
        }

          this.entityElements = filteredElements.sort((ea,eb)=> ea.toLowerCase() < eb.toLowerCase() ? -1 : 1);
          if(this.filteredBy  == undefined) this.filteredBy = event.sourceField;
      }else if(filteredElements.length == 0){
        this.entityElements = filteredElements.sort((ea,eb)=> ea.toLowerCase() < eb.toLowerCase() ? -1 : 1);
        if(this.filteredBy  == undefined) this.filteredBy = event.sourceField;
      }else if(filteredElements.length == 1 && elementsMatched == 0){
        this.entityElements = filteredElements.sort((ea,eb)=> ea.toLowerCase() < eb.toLowerCase() ? -1 : 1);
        if(this.filteredBy  == undefined) this.filteredBy = event.sourceField;
      }




      }
    }


    var origin = event.originField;

    if(origin == undefined || origin == null){
      origin = event.sourceField;
    }

    this.filterLastExecution = event.executionTimestamp;
    //Seteamos el valor

    //Si el valor actual ya está en los elementos filtrados no tenemos que hacer nada
    if( (this.isCurrentValueInFilteredElements(filteredElements) && filteredElements.length == 1 )
          || (this.userSelected && this.fieldProps.value.length > 0 )){
            let changeValue = false;

            if(this.isCurrentValueInFilteredElements(filteredElements) && filteredElements.length == 1){
              this.fieldProps.value = this.fieldProps.value.filter( v => filteredElements.includes(v));
            }else if(filteredElements.length == 1){
              this.fieldProps.value = this.entityElements.filter( v => filteredElements.includes(v));
              changeValue = true;
            }else if(this.fieldProps.value.length > 0){
                //Comprobamos si quitamos algún valor
                this.fieldProps.value = this.fieldProps.value.filter( cv => filteredElements.includes(cv));
                if(this.fieldProps.value.length == 0){
                  //Hay que propagar un evento con lo filtrado
                  let completeValues = this.availableElements.filter(e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key
                    && filteredElements.includes(attr.value)))
                  this.onChangeValue.emit({values:completeValues,impactedFields:impactedFields,
                   sourceField:this.fieldProps.key,fieldEntity:this.fieldEntity,originField:origin,depGroups:event.depGroups});
                }else{
                  changeValue = true;
                }
            }
            let prevValues = this.fieldProps.value.length;
            if(prevValues != this.fieldProps.value.length || changeValue){
              //Hay que disparar el evento de cambio
                let completeValues = this.availableElements.filter(e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key && this.fieldProps.value.includes(attr.value)))
               this.onChangeValue.emit({values:completeValues,impactedFields:impactedFields,
                sourceField:this.fieldProps.key,fieldEntity:this.fieldEntity,originField:origin,depGroups:event.depGroups});
            }
      return;
    }else/* if(!this.fieldProps.multiple){
      this.fieldProps.value = [];
    }else if(!this.userSelected && this.fieldProps.value.length > 0){
      //ES un campo multiple
      //Comprobamos los elementos que coinciden
      var matchElements = filteredElements.reduce((a, c) => a + this.fieldProps.value.includes(c), 0);
      var valoresConsolidados = [...new Set(this.fieldProps.value.concat(filteredElements))];

      if (this.fieldProps.value.length > matchElements ){
        this.fieldProps.value = filteredElements;
      }else if(filteredElements.length - matchElements >= 1 ){
        //Coincide todos los elementos y se está añadiendo uno
        this.fieldProps.value = valoresConsolidados;
      }

      console.log("Como cambiamos la selección");
    }else if(!this.userSelected)*/{
      this.fieldProps.value = [];
    }



    if(event.values.length == 0){
      //Es un clearall
      this.fieldProps.value = [];
    }else if(filteredElements.length == 1  && !this.userSelected){
      this.fieldProps.value = filteredElements;

      let completeValues = this.availableElements.filter(e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key && this.fieldProps.value.includes(attr.value)))




      this.onChangeValue.emit({values:completeValues,impactedFields:impactedFields,
        sourceField:this.fieldProps.key,fieldEntity:this.fieldEntity,originField:origin,depGroups:event.depGroups});
    }else if(filteredElements.length > 1 && !this.userSelected){

      let completeValues = this.availableElements.filter(e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key && filteredElements.includes(attr.value)))

      this.onChangeValue.emit({values:completeValues,impactedFields:impactedFields,
        sourceField:this.fieldProps.key,fieldEntity:this.fieldEntity,originField:origin,depGroups:event.depGroups});

    }



  }
   getIntersection(a, b) {
    const set1 = new Set(a);
    const set2 = new Set(b);

    const intersection = [...set1].filter(
      element => set2.has(element)
    );

    return intersection;
  }

  getValueForDependencyGroups(): any {
    let completeValues = this.availableElements.filter
        (e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key
              && this.fieldProps.value.includes(attr.value)));
    return completeValues;
  }

  getFilteredCompleteValues(){
    return this.availableElements.filter(e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key
      && this.entityElements.includes(attr.value)))

  }
  isCurrentValueInFilteredElements(filteredElements: any) {
    let r = false;

    if(this.fieldProps.multiple){
      //Si es multiple comprobamos si al menos
      if(this.fieldProps.value != undefined
        && this.fieldProps.value != null && this.fieldProps.value.length > 0){
          const matched = this.fieldProps.value.reduce((a, c) => a + filteredElements.includes(c), 0);
          r = matched > this.fieldProps.value.length;
      }
    }else{
      if(this.fieldProps.value != undefined
        && this.fieldProps.value != null && this.fieldProps.value.length > 0){
          const matched = this.fieldProps.value.reduce((a, c) => a + filteredElements.includes(c), 0);
          r = matched === this.fieldProps.value.length;
      }
    }



    return r;
  }

  onChange(event: any) {
    this.isChanged = true;
  }

  getSelectedValues(){

    if(this.fieldProps.value !=undefined && this.fieldProps.value !=null && this.fieldProps.value.length > 0){
      return this.availableElements.filter(e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key
        && this.fieldProps.value.includes(attr.value)))
      .map(e => {
        var selVal = {id: e.entity_id};
        selVal[this.fieldProps.customEntityConfig.key]  = e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key).value;

        if(this.fieldProps.customEntityConfig.key == 'name'){
         selVal['element_id'] = e.id;
        }

        return selVal;
      }).filter((value, index, self) =>
      index === self.findIndex((t) => {
       return t[this.fieldProps.customEntityConfig.key] === value[this.fieldProps.customEntityConfig.key];
    }));
    }/*else if (this.getFilteredCompleteValues().length < this.availableElements.length){
        return this.getFilteredCompleteValues().map(e => {
          var selVal = {id: e.entity_id};
          selVal[this.fieldProps.customEntityConfig.key]  =
              e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key).value;
          return selVal;
        });
    }*/


  }
  onCloseDropDown(){
    if(this.isChanged){
      this.userSelected = true;
      let completeValues = this.availableElements.filter(e => e.attributes.find(attr => attr.id == this.fieldProps.customEntityConfig.key && this.fieldProps.value.includes(attr.value)))
      this.onChangeValue.emit({values:completeValues,sourceField:this.fieldProps.key,fieldEntity:this.fieldEntity});
      if(completeValues.length == 0){
        this.fillOriginalElements();
        delete this.filteredBy;
      }
      this.isChanged = false;
    }
  }
}
